<template>
  <div class="activity-wrap">
    <app-header />
    <div class="app">
      <div class="banner">
        <img
          src="../../assets/images/activity/activity20250403/01.jpg"
          alt=""
          style="width: 100%;"
        />
        <img
          src="../../assets/images/activity/activity20250403/02.png"
          alt=""
          class="banner-btn"
          @click="handleClickOpen"
        />
      </div>
      <div class="content">
        <div class="img03-box">
          <img
            src="../../assets/images/activity/activity20250403/03.jpg"
            alt=""
          />

          <img
            src="../../assets/images/activity/activity20250403/04.png"
            alt=""
            class="img04"
            @click="handleClickOpen"
          />
        </div>

        <div class="bgcolor">
          <div class="box">
            <p style="text-align: center;">
              <img
                src="../../assets/images/activity/activity20250403/05.png"
                alt=""
              />
            </p>
            <div class="carousel1">
              <el-carousel :interval="10000" arrow="always" height="650px">
                <el-carousel-item>
                  <img
                    src="../../assets/images/activity/activity20250403/06_1.jpg"
                    alt=""
                  />
                </el-carousel-item>
                <el-carousel-item>
                  <img
                    src="../../assets/images/activity/activity20250403/06_2.jpg"
                    alt=""
                  />
                </el-carousel-item>
                <el-carousel-item>
                  <img
                    src="../../assets/images/activity/activity20250403/06_3.jpg"
                    alt=""
                  />
                </el-carousel-item>
              </el-carousel>
            </div>

            <p style="text-align: center;">
              <img
                src="../../assets/images/activity/activity20250403/07.png"
                alt=""
                style="margin: 40px 0 10px;"
              />
            </p>

            <div class="carousel2">
              <el-carousel :interval="10000" arrow="always" height="650px">
                <el-carousel-item>
                  <img
                    src="../../assets/images/activity/activity20250403/08_01.jpg"
                    alt=""
                    style="margin-top: 10px;"
                  />

                  <img
                    src="../../assets/images/activity/activity20250403/08_01s.gif"
                    alt=""
                  />
                </el-carousel-item>
                <el-carousel-item>
                  <img
                    src="../../assets/images/activity/activity20250403/08_02.jpg"
                    alt=""
                    style="margin-top: 10px;"
                  />

                  <img
                    src="../../assets/images/activity/activity20250403/08_02s.png"
                    alt=""
                  />
                </el-carousel-item>
                <el-carousel-item>
                  <img
                    src="../../assets/images/activity/activity20250403/08_03.jpg"
                    alt=""
                    style="margin-top: 10px;"
                  />

                  <img
                    src="../../assets/images/activity/activity20250403/08_03s.jpg"
                    alt=""
                  />
                </el-carousel-item>
              </el-carousel>
            </div>

            <div style="text-align: center;">
              <img
                src="../../assets/images/activity/activity20250403/09.png"
                alt=""
                style="margin-top: 50px"
                class="img04"
                @click="handleClickOpen"
              />
            </div>
          </div>
        </div>

        <div style="text-align: center; padding-top: 30px;">
          <img
            src="../../assets/images/activity/activity20250403/09.jpg"
            alt=""
          />
        </div>
      </div>

      <div class="footer">
        <div class="footer_content">
          <img
            src="../../assets/images/activity/activity20250403/10.png"
            alt=""
            @click="handleClickOpen"
          />
        </div>
      </div>

      <div class="shade_bg" v-if="shadeBg">
        <!-- 支付成功 -->
        <img
          src="../../assets/images/activity/_20240801/17.png"
          class="accomplish"
          alt=""
          v-if="accomplish"
          @click="
            shadeBg = false;
            accomplish = false;
            order = false;
          "
        />

        <!-- 订单生成 -->
        <div class="order_bg" v-if="order">
          <div class="con">
            <p>订单已生成，还差一步</p>
            <p>
              即可开通大智慧 365
            </p>
            <p>确定放弃购买吗？</p>

            <div class="pay_btn">
              <button
                class="abandon"
                @click="
                closeOrder()"
              >
                忍痛放弃
              </button>
              <button class="goon" @click="handleClickgoon">继续支付</button>
            </div>
          </div>
        </div>

        <!-- 支付 -->
        <div class="pay_bg" v-if="pay">
          <img
            src="../../assets/images/activity/_20240801/23.png"
            alt=""
            class="close"
            @click="handlePayClickClose"
          />
          <div class="pay_bg2">
            <div class="pay_left">
              <img
                src="../../assets/images/activity/activity20250403/11.png"
                alt=""
              />

              <ul class="sel_price">
                <li
                  v-for="(item, index) in priceList"
                  :key="index"
                  @click="switchAttch(index)"
                  :class="priceIndex == index ? 'priceChecked' : ''"
                >
                  <div>
                    <img
                      src="../../assets/images/activity/activity20250403/12.png"
                      alt=""
                      class="checkedImg"
                      v-if="priceIndex == index"
                    />
                    <span class="discount" v-if="index === 0 && canDiscount">{{ item.tital }}</span>
                    <p class="type">{{ item.type }}</p>
                    <p class="price">
                      <span>¥</span>{{ item.price }}<span>/{{ item.le }}</span>
                    </p>
                    <p class="originalPrice" v-show="canDiscount">
                      <i v-if="item.originalPrice">原价</i
                      >{{ item.originalPrice }}
                    </p>
                  </div>
                </li>
              </ul>

              <div class="hint">
                购买后获得一个月大智慧365软件权
                益，到期前一天按83元/月自动续费， 可随时取消。
              </div>
            </div>
            <div class="pay_right">
              <!-- 包月 -->
              <div v-if="priceIndex === 0">
                <img
                  src="../../assets/images/activity/activity20250403/13.png"
                  alt=""
                  class="checkedImg"
                  style="margin-top: 50px;"
                  v-show="canDiscount"
                />
                <img
                  src="../../assets/images/activity/activity20250403/13-1.png"
                  alt=""
                  class="checkedImg"
                  style="margin-top: 50px;"
                  v-show="!canDiscount"
                />

                <img
                  src="../../assets/images/activity/activity20250403/14.png"
                  alt=""
                  class="checkedImg"
                  @click="saveOrder()"
                  style="margin-top: 10px;"
                />
              </div>
              <!-- 年卡 -->
              <div v-if="priceIndex === 1">
                <p class="code">
                  <qriously
                    :value="qrData"
                    :size="260"
                    level="M"
                    v-show="qrData"
                  />
                </p>

                <ul class="pay_list">
                  <li
                    v-for="(item, index) in payList"
                    :key="index"
                    :class="handlePayClickIndex == index ? 'payClick' : ''"
                    @click="changeMode(item.payMode, index)"
                  >
                    <div>
                      <p>
                        <img :src="item.img" alt="" />
                      </p>

                      <p>
                        {{ item.name }}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              <div style="text-align: left;margin-top: 20px;">
                <p class="p2" v-if="priceIndex === 0">
                  <el-checkbox v-model="checked"></el-checkbox>
                  我已知晓<a href="#"
                    ><router-link to="/protocol" target="_blank"
                      >软件许可协议
                    </router-link></a
                  >
                  <a href="#"
                    ><router-link to="/protocol" target="_blank">
                      丨付费授权协议</router-link
                    ></a
                  >
                  <a href="#"
                    ><router-link to="/protocol" target="_blank"
                      >丨自动续费协议</router-link
                    ></a
                  >
                </p>

                <p class="p2" v-if="priceIndex === 1">
                  已经阅读并同意<a href="#"
                    ><router-link to="/protocol" target="_blank"
                      >《使用软件产品许可协议》</router-link
                    ></a
                  >
                </p>

                <p class="p3">
                  发票信息：电子普通发票
                  <span v-if="this.invoiceTitleType == 1">个人</span>
                  <span v-else>单位</span>
                  信息技术服务 <a @click="openInvoice">发票填开></a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 电子发票组件 -->
        <invoice @changeInvoiceTitleType="changeInvoiceTitleType" ref="invoice" />
      </div>
    </div>
  </div>
</template>
<script></script>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
import Invoice from "@/components/invoice/Invoice.vue";

export default {
  components: {
    AppHeader,
    Invoice
  },
  data() {
    return {
      shadeBg: false,
      accomplish: false,
      order: false,
      pay: false,
      payList: [
        {
          img: require("../../assets/images/activity/_20240801/20.png"),
          name: "微信支付",
          payMode: 23
        },
        {
          img: require("../../assets/images/activity/_20240801/21.png"),
          name: "支付宝",
          payMode: 29
        },
        {
          img: require("../../assets/images/activity/_20240801/22.png"),
          name: "其他支付",
          payMode: 0
        }
      ],
      handlePayClickIndex: 0,
      s: this.$route.query.s,
      orderId: "",
      signOrderId: this.$route.params.orderId,
      signMothed: this.$route.query.method,
      signParams: '',
      qrData: "",
      payMode: 37,
      aliPayQrCode: "",
      wechatPayQrCode: "",
      lastInvoiceTitleType: 1,
      invoiceTitleType: 1,
      timer: "",
      priceList: [
        {
          tital : "首月特惠",
          type: "连续包月",
          price: 39.9,
          originalPrice: 83,
          month: 1,
          le: "月"
        },
        {
          type: "年卡",
          price: 998,
          month: 12,
          le: "年"
        }
      ],
      priceIndex: 0,
      month: 1,
      checked: true,
      renewPaid: false,
      hadRenew: false,
      canDiscount: true,
      lock: false,
    };
  },
  created() {
    var index = window.location.href.indexOf("?");
    if (index > -1) {
      this.signParams = window.location.href.substring(index);
    }
    if(!this.s){
      this.s = "";
    }
    if(!this.signOrderId || this.signOrderId === "0"){
      this.signOrderId = '';
    }
    //签约结果页面回调
    if(this.signMothed){
      this.signReturn(this.signMothed)
    }
    //校验用户是否存在收费权限
    this.checkPower()
  },
  mounted() {
    this.invoiceTitleType = this.$refs.invoice.invoiceTitleType;
  },
  beforeDestroy() {
    document.body.style.overflow = "";
    if (this.timer) {
      clearInterval(this.timer);
    }
    document.body.removeAttribute("class", "bodyWidth");
  },
  watch: {
    shadeBg(newValue) {
      if (newValue) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    }
  },
  methods: {
    checkPower() {
      this.$get("/user/checkPower")
        .then(response => {
          if (response.code === 0) {
            this.priceList[0].price = 83.0;
            this.priceList[0].originalPrice = 83.0;
            // this.priceList[0].type = '';
            this.priceList[0].tital = '';
            this.canDiscount = false
            if(this.isRetrun){
              this.isRetrun = false;
              return false;
            }
            this.$global.alert("您已有大智慧高端软件权限，无法参与本活动！");
          } else {
            this.priceList[0].price = 39.9;
            this.priceList[0].originalPrice = 83;
            this.priceList[0].type = '连续包月';
          }
        })
        .catch(err => {
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    signReturn(val) {
      if(val !== 'alipay.user.agreement.page.sign.return'){
        this.$global.alert('非法请求');
        return;
      }
      this.shadeBg = true;
      this.accomplish = true;
      this.renewPaid = true;
      this.isRetrun = true;
    },

    handlePayClickClose: function() {
      this.pay = false;
      this.order = true;
    },
    closeOrder: function() {
      this.shadeBg = false;
      this.order = false;
      this.accomplish = false;
      if(this.timer){
        clearInterval(this.timer)
      }
    },

    handleClickgoon: function() {
      this.pay = true;
    },

    handleClickOpen: function() {
      this.shadeBg = true;
      this.pay = true;
    },
    switchAttch(index){
      this.priceIndex = index;
      this.month = this.priceList[index].month
      if(index == 1){
        this.payMode = 23;
        this.saveOrder()
      }
    },
    changeMode(payMode, index) {
      this.handlePayClickIndex = index;
      this.payMode = payMode;
      if (this.payMode == 0) {
        var routerDate = this.$router.resolve({
          name: "OrderPay",
          params: { orderId: this.orderId }
        });
        let href = routerDate.href;
        window.location.href = href;
      } else {
        if(payMode == 23 && this.wechatPayQrCode!=''){
          this.qrData = this.wechatPayQrCode;
          return;
        }
        if(payMode == 29 && this.aliPayQrCode!=''){
          this.qrData = this.aliPayQrCode;
          return;
        }
        this.getQrCode(this.orderId, this.payMode);
      }
    },
    saveOrder() {
      if(this.renewPaid && this.priceIndex == 0){
        this.$global.alert("您已经购买大智慧365自动续费");
        return false;
      }
      var url = '/order/signOrderSave';
      var params = {
        productId: 116,
        monthCount: this.month,
        orderType: 0,
        convertMoney: 0,
        invoiceTitleType: this.invoiceTitleType,
        questionsId: "0",
        buySource: this.s
      };
      if(this.priceIndex == 1){
        if(this.orderId && this.orderId != ''){
          this.getQrCode()
          return;
        }
        params.monthCount = 12
        url = '/order/save'
      }else{
        if(!this.checked){
          this.$alert(
          "请仔细阅读“软件许可协议 丨付费授权协议 丨自动续费协议”，阅读结束后同意请选中“我已知晓”钩选框，然后继续购买。",
          "提示",
          {
            confirmButtonText: "确定"
          }
        );
          return false;
        }
        params.signReturnUrl = window.location.href;
      }
      this.$post(url, params)
        .then(response => {
          if (response.code === 0) {
            if(this.priceIndex == 0){
              this.signOrderId = response.data.id;
            }
            if(this.priceIndex == 1){
              this.orderId = response.data.id;
            }
            this.getQrCode()
          } else {
            if(this.priceIndex == 0 && response.code === 203){
              this.hadRenew = true
            }
            this.$global.alert(response.msg);
            }
          })
        .catch(err => {
        this.$global.alertError();
      });
    },
    getQrCode() {
      var orderId = this.orderId;
      var payMode = this.payMode;
      var payUrl = '/pay/sign'
      if(this.priceIndex == 0 ){
        payMode = 37
        orderId = this.signOrderId;
        if(this.hadRenew == true){
          return false;
        }
      }else{
        payUrl = "/pay/qrcode";
      }
      if (this.lock) {
        return false;
      }
      var params = {
        id: orderId,
        payMode: payMode
      };
      this.lock = true;
      this.$get(payUrl, params)
        .then(response => {
          if (response.code === 0) {
            if(this.priceIndex == 1){
              this.qrData = response.data;
              if(payMode == 23){
                this.wechatPayQrCode = this.qrData;
              }else if(payMode == 29){
                this.aliPayQrCode = this.qrData;
              }
              this.getOrderStatusTimer(this.orderId)
            }else{
              var signCodeUrl = response.data;
              window.location.href = signCodeUrl;
            }
          }else{
            this.$global.alert(response.msg);
          }
          this.lock = false;
        })
        .catch(err => {
          this.lock = false;
        });
    },
    getOrderStatusTimer(val) {
      if(this.timer && this.timer!= ""){
        return
      }
      var count = 60;
      this.timer = setInterval(() => {
        if (count <= 0) {
          clearInterval(this.timer);
        } else {
          count--;
          this.$get("/order/status?id=" + val).then(response => {
          if (response.code === 0 && response.data === 1) {
            this.accomplish = true;
            this.pay = false;
            this.order = false;
            this.orderId = '';
            clearInterval(this.timer)
            this.aliPayQrCode = "";
            this.wechatPayQrCode = "";
          }
        })
        }
      }, 5000);
    },
    openInvoice() {
      //调用子组件发票抬头类型
      this.$refs.invoice.openInvoice();
    },
    changeInvoiceTitleType(invoiceTitleType) {
      //获取发票组件发票抬头类型
      this.invoiceTitleType = invoiceTitleType;
      if (this.invoiceTitleType !== this.lastInvoiceTitleType) {
        this.lastInvoiceTitleType = this.invoiceTitleType;
        this.updatePaymentInvoiceTitleType();
      }
    },
    updatePaymentInvoiceTitleType() {
      this.$get(
        "/order/updateInvoiceTitleType?orderId=" +
          this.orderId +
          "&invoiceTitleType=" +
          this.invoiceTitleType
      )
        .then(response => {
          if (response.code !== 0) {
            this.alert(response.msg);
          }
        })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  max-width: 1920px;
  min-width: 900px;
  margin: 0 auto;
  position: relative;
  .banner-btn {
    position: absolute;
    left: 45%;
    top: 50%;
    width: 10%;
    cursor: pointer;
    animation: click-animation 1.2s infinite;
  }
  @keyframes click-animation {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(0.9);
    }
  }
}

.content {
  padding-bottom: 30px;
  .img03-box {
    width: 900px;
    margin: 0 auto;
    text-align: center;
  }

  .img04 {
    cursor: pointer;
    animation: click-animation 1.2s infinite;
    margin: 20px 0 40px 0;
  }
}

.btn01 img:hover {
  -webkit-animation: scale-up-center 0.5s forwards;
  animation: scale-up-center 0.5s forwards;
}

@-webkit-keyframes scale-up-center {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scale-up-center {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.footer {
  background: #2c2d2d;
}

.footer .footer_content {
  width: 676px;
  height: 70px;
  position: relative;
  margin: 0 auto;
  img {
    position: absolute;
    top: -22px;
    cursor: pointer;
  }
}

.bgcolor {
  background: #efefef;
  .box {
    width: 920px;
    margin: 0 auto;
    padding: 20px 0;
  }
}

.carousel1 {
  overflow: hidden;
  margin-top: 16px;
  height: 650px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.28);
  text-align: center;
}

.carousel2 {
  overflow: hidden;
  margin-top: 16px;
  height: 650px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.28);
  text-align: center;
}

.shade_bg {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  z-index: 99;
  .close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
  }
  .accomplish {
    position: fixed;
    width: 373px;
    height: 400px;
    top: 50%;
    margin-top: -200px;
    left: 50%;
    margin-left: -186.5px;
  }

  .order_bg {
    background: url("../../assets/images/activity/_20240801/18.png") no-repeat
      center top;
    position: fixed;
    width: 430px;
    height: 244px;
    top: 50%;
    margin-top: -122px;
    left: 50%;
    margin-left: -215px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    .con {
      p {
        &:nth-child(1) {
          font-size: 24px;
          color: #2b2b2b;
          font-weight: 800;
        }
        &:nth-child(2) {
          margin-top: 30px;
        }
        &:nth-child(3) {
          margin-top: 5px;
        }
        &:nth-child(2),
        &:nth-child(3) {
          font-size: 18px;
          color: #d97844;
        }
      }

      .pay_btn {
        margin-top: 30px;
        button {
          border: none;
          width: 165px;
          height: 50px;
          border-radius: 30px;
          font-size: 18px;
          font-weight: 800;
        }

        .goon {
          color: #7c390f;
          background: linear-gradient(to right, #f1bc9e, #fce8d6);
          margin-left: 20px;
        }
      }
    }
  }

  .pay_bg {
    background: #f8f8f8;
    width: 900px;
    position: fixed;
    top: 15%;
    left: 50%;
    margin-left: -450px;
    border-radius: 10px;
    .pay_bg2 {
      display: flex;
      padding: 40px;
      height: 519px;
      box-sizing: border-box;

      .pay_right {
        text-align: center;
        position: relative;
        padding-left: 25px;
        width: 100%;
        .close {
          position: absolute;
          right: 20px;
          top: 20px;
          width: 18px;
          height: 18px;
          cursor: pointer;
        }

        .code {
          text-align: center;
          margin-top: 25px;
          width: 240px;
          height: 240px;
          background-color: #fff;
          display: inline-block;
        }
        .pay_list {
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-top: 30px;
          li {
            position: relative;
            width: 75px;
            height: 75px;
            flex-shrink: 0;
            margin: 0 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &::before {
              position: absolute;
              content: "";
              border-right: 1px solid #e2ab24;
              height: 55px;
              right: -24px;
            }
            &:last-child {
              border: none;
              &::before {
                display: none;
              }
            }
            img {
              width: 20px;
              height: 20px;
              margin-bottom: 10px;
            }
          }
          .payClick {
            background: #e4e4e4;
            border-radius: 10px;
          }
        }

        .p2 {
          font-size: 12px;
          color: #777777;
          margin-top: 10px;
          a {
            color: #1997ff;
          }
        }

        .p3 {
          font-size: 12px;
          color: #777777;
          margin-top: 10px;
          a {
            color: #1997ff;
            margin-left: 10px;
          }
        }
      }
      .pay_left {
        border-right: 1px solid #ededed;
        padding-right: 25px;
        &::before {
          background: url("../../assets/images/activity/_20240801/19.png")
            no-repeat left top;
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 490px;
          opacity: 0.3;
          z-index: -1;
        }
        .sel_price {
          margin-top: 50px;
          display: flex;
          li {
            width: 200px;
            height: 200px;
            border-radius: 15px;
            background: #fff;
            padding: 20px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            position: relative;
            cursor: pointer;
            &:first-child {
              margin-right: 30px;
            }
            .discount {
              position: absolute;
              padding: 2px 5px;
              font-size: 14px;
              color: #fff;
              border-radius: 10px 0 10px 0;
              background-image: linear-gradient(to right, #ff7933, #ff187c);
              left: 0px;
              top: -15px;
            }
            .type {
              font-size: 20px;
              color: #4d0819;
              font-weight: 700;
            }
            .price {
              font-size: 48px;
              color: #4d0819;
              font-weight: 700;
              span {
                font-size: 25px;
              }
            }
            .checkedImg {
              position: absolute;
              right: 0;
              top: 0;
            }
            .originalPrice {
              font-size: 16px;
              color: #c67741;
              height: 20px;
              line-height: 20px;
              text-decoration: line-through;
            }
          }
          .priceChecked {
            background: #ffe6b4;
            .price {
              color: #f51572;
            }
          }
        }

        .hint {
          width: 200px;
          font-size: 12px;
          color: #636363;
          margin-top: 10px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activity20250403.vue